// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchUserPanel_container__hMlLr","button":"SwitchUserPanel_button__3YseE"};